import radiosAsSelect from '../utils/forms/radios-as-select';
import formSubmitOnce from '../utils/forms/form-submit-once';
import toggleOrderSummaryProducts from './order-summary';
import fixDeliverEmptyAnchors from './fix-delivery-empty-anchors';
import relatedFormSectionsToggle from './related-form-sections-toggle';
import upgradeFormHandlers from './upgrade-form-handlers';
import abandonBasketReminders from './abandon-basket-reminders';
import storesSearch from '../stores-search';
import networkSwitching from './network-switching';
import adobeAnalytics from '../adobe-analytics/adobe-analytics';
import basket from './basket';
import promotion from './promotion';
import numericKeyboard from './numeric-keyboard';
import insurance from '../insurance';
import esim from './esim';
import contentSquare from './content-square';

const radioAsSelectSelectors = [
    '[data-radios-as-select]',
    '#form_name_title_row',
    '#form_bank_timeWithBank_row'
];

basket();
promotion();
numericKeyboard();
radiosAsSelect(radioAsSelectSelectors.join(','));
toggleOrderSummaryProducts();
fixDeliverEmptyAnchors();
relatedFormSectionsToggle();
upgradeFormHandlers();
formSubmitOnce(false);
abandonBasketReminders();
storesSearch();
networkSwitching();
adobeAnalytics();
insurance();
esim();
contentSquare();
